import { blue, cyan, green, neutral, orange, pink, purple, red } from './colors';
export const themeColorsLight = {
    primary: {
        base: blue['700'],
        hover: blue['800'],
        pressed: blue['900'],
        border: blue['300'],
        alpha: blue['alpha-100'],
        surface: blue['50'],
    },
    secondary: {
        base: red['700'],
        hover: red['800'],
        pressed: red['900'],
        border: red['300'],
        alpha: red['alpha-100'],
        surface: red['50'],
    },
    background: neutral['100'],
    surface: {
        primary: neutral['00'],
        secondary: neutral['100'],
        tertiary: neutral['00'],
        hover: neutral['100a'],
        pressed: neutral['300'],
        disable: neutral['200'],
        inverse: neutral['1100'],
    },
    overlay: {
        primary: neutral['00'],
        primaryAlpha: neutral['00'] + '18',
        secondary: neutral['200'],
        hover: neutral['200a'],
        pressed: neutral['300'],
        disable: neutral['200'],
        inverse: neutral['1100'],
        still: neutral['00'],
    },
    text: {
        bold: neutral['00-d'],
        main: neutral['1000'],
        subtle: neutral['700'],
        disable: neutral['500'],
        inverse: neutral['00'],
        link: blue['700'],
    },
    icon: {
        bold: neutral['00-d'],
        main: neutral['1000'],
        subtle: neutral['700'],
        disable: neutral['500'],
        inverse: neutral['00'],
        link: blue['700'],
    },
    border: {
        main: neutral['300'],
        bold: neutral['500'],
        boldest: neutral['700'],
    },
    alphaDarkSurface: {
        subtlest: neutral['100a'],
        subtle: neutral['200a'],
        base: neutral['300a'],
        bold: neutral['400a'],
        boldest: neutral['500a'],
    },
    alphaLightSurface: {
        subtlest: neutral['100a-d'],
        subtle: neutral['200a-d'],
        base: neutral['300a-d'],
        bold: neutral['400a-d'],
        boldest: neutral['500a-d'],
    },
    accent: {
        blue: {
            subtlest: blue['50'],
            subtle: blue['200'],
            base: blue['600'],
            bold: blue['800'],
            boldest: blue['1000'],
            alpha: blue['alpha-100'],
        },
        green: {
            subtlest: green['50'],
            subtle: green['200'],
            base: green['600'],
            bold: green['800'],
            boldest: green['1000'],
            alpha: green['alpha-100'],
        },
        orange: {
            subtlest: orange['50'],
            subtle: orange['200'],
            base: orange['600'],
            bold: orange['900'],
            boldest: orange['1000'],
            alpha: orange['alpha-100'],
        },
        red: {
            subtlest: red['50'],
            subtle: red['200'],
            base: red['600'],
            bold: red['800'],
            boldest: red['1000'],
            alpha: red['alpha-100'],
        },
        grey: {
            subtlest: neutral['200'],
            subtle: neutral['400'],
            base: neutral['600'],
            bold: neutral['800'],
            boldest: neutral['1000'],
            alpha: neutral['300a'],
        },
        pink: {
            subtlest: pink['50'],
            subtle: pink['200'],
            base: pink['600'],
            bold: pink['800'],
            boldest: pink['1000'],
            alpha: pink['alpha-100'],
        },
        purple: {
            subtlest: purple['50'],
            subtle: purple['200'],
            base: purple['400'],
            bold: purple['800'],
            boldest: purple['1000'],
            alpha: purple['alpha-100'],
        },
        cyan: {
            subtlest: cyan['50'],
            subtle: cyan['300'],
            base: cyan['600'],
            bold: cyan['800'],
            boldest: cyan['1000'],
            alpha: cyan['alpha-100'],
        },
    },
    decorative: {
        white: neutral['00'],
        black: neutral['00-d'],
        pink: pink['500'],
        red: red['700'],
        orange: orange['800'],
        green: green['800'],
        blue: blue['800'],
        purple: purple['700'],
        cyan: cyan['800'],
    },
};
